

import Form from "../../componets/Form";

export default function Section10() {
  return (
    <Form />
  );
}
